<template>
  <v-dialog
    v-model="showPopup"
    persistent
    max-width="650"
    @keydown.passive.esc="$emit('cancel')"
  >
    <v-card class="pa-4">
      <v-card-title class="headline justify-center popup-title">
        Location Details
      </v-card-title>
      <v-card-text>
        <div class="home-content pt-4 pb-4">
          <v-row>
            <v-col cols="7">
              <v-row>
                <v-col cols="12">
                  <div class="label-text">Location Label</div>
                  <div class="label-text location-name">
                    {{ rackLabel }}&nbsp;{{ shelfLabel }}&nbsp;{{ binLabel }}
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="label-text">Total Number of Items</div>
                  <div class="label-text location-name">
                    {{ items.length ? items.length : 'Available bin' }}
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="5">
              <div class="bin-barcode">
                <img :src="binBarcode" width="200" />
              </div>
            </v-col>
          </v-row>
          <v-row v-if="items.length > 0">
            <v-col cols="12">
              <div class="label-text">Items</div>
              <div class="table-items">
                <v-row class="table-items-head">
                  <v-col cols="6">Title</v-col>
                  <v-col cols="4">SKU</v-col>
                  <v-col cols="2">Qty</v-col>
                </v-row>
                <v-row class="table-items-tbody light">
                  <v-col>
                    <v-row v-for="(item, idx) in items" :key="idx">
                      <v-col cols="6">{{ item.name }}</v-col>
                      <v-col cols="4">{{ item.sku }}</v-col>
                      <v-col cols="2">{{ item.value }}</v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <v-card-actions class="text-xs-center justify-center">
        <v-btn
          @click="$emit('cancel')"
          depressed
          class="save-btn small-size"
        >
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'WarehouseMapBinItemsPopup',
  props: {
    showPopup: {
      type: Boolean,
      required: true
    },
    warehouse: {
      type: Object,
      required: false
    },
    rack: {
      type: Object,
      required: false
    },
    shelf: {
      type: Object,
      required: false
    },
    bin: {
      type: Object,
      required: false
    },
    binItems: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      valid: false
    }
  },
  computed: {
    rackLabel() {
      return this.rack?.label || ''
    },
    shelfLabel() {
      return this.shelf?.label || ''
    },
    binLabel() {
      return this.bin?.label || ''
    },
    binBarcode() {
      return this.bin?.barcode || ''
    },
    items() {
      return this.binItems?.items || []
    }
  }
}
</script>

<style scoped lang="scss">
.bin-barcode {
  width: 100%;
  max-width: 200px;
  height: 120px;
  padding: 15px;
  border-radius: 10px;
  background-color: #ffffff;
  border: 1px solid rgba(0,0,0,0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
  }
}

.location-name {
  color: #43425D !important;
}

.table-items {
  padding: 15px 0;
  margin: 0 10px;

  > .table-items-head {
    background-color: rgba(0, 0, 0, 0.05);
    padding-right: 5px;

    > .col {
      padding: 5px 10px;
      font-weight: 500;
      font-size: 12px;
    }
  }

  .table-items-tbody {
    max-height: 120px;
    overflow-x: hidden;
    overflow-y: scroll;

    .row {
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);

      > .col {
        padding: 8px 10px;
        font-size: 14px;
      }
    }
  }
}

.light::-webkit-scrollbar {
  width: 5px;
}

.light::-webkit-scrollbar-track {
  background: #e6e6e6;
  border-left: 1px solid #dadada;
}

.light::-webkit-scrollbar-thumb {
  background: #b0b0b0;
  border: solid 1px #e6e6e6;
  border-radius: 2px;
}

.light::-webkit-scrollbar-thumb:hover {
  background: #73727E;
}
</style>
